import vuex from "vuex";
import localStorage from "../../helper/localStorage";
import http from "../../helper/http";
import { merge, sortBy, flatten, reverse } from 'lodash'

let state = {
    params: {},
    resData: {},
    subLoading: false,
    requestUrl: ''
}

const getters = {

}

const actions = {
    /**
     * 提交数据增改请求
     * @param {*} param0 
     * @param {*} params 
     */
    async dscsDataStoreSubmit({ state, commit }, params) {
        commit('setInitStore', params);
        return http.post(state.requestUrl, state.params).then(async res => {
            await commit('setDscsDataStoreSubmit', res);
        }).catch(err => {
            commit('setDscsDataStoreSubmit', false);
        })
    }
}

const mutations = {
    /**
     * 加载数据
     * @param {*} state 
     * @param {*} v 
     */
    setDscsDataStoreSubmit(state, v) {
        state.resData = v;
        state.subLoading = false;
    },
    /**
     * 设置初始化参数
     * @param {*} state 
     * @param {*} params 
     */
    setInitStore(state, params) {
        state.params = {};
        merge(state, params);
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/dataidscstorehelper.js